import { render, staticRenderFns } from "./customize.vue?vue&type=template&id=79a32466&scoped=true"
import script from "./customize.vue?vue&type=script&lang=js"
export * from "./customize.vue?vue&type=script&lang=js"
import style0 from "./customize.vue?vue&type=style&index=0&id=79a32466&prod&lang=scss&scoped=true"
import style1 from "./customize.vue?vue&type=style&index=1&id=79a32466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a32466",
  null
  
)

export default component.exports